
import React from 'react';
import { Button } from '@/components/ui/button';
import { Square, X, CirclePlay } from 'lucide-react';

interface RecordingControlsProps {
  isRecording: boolean;
  isReadyToRecord: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
  onCancel: () => void;
}

const RecordingControls: React.FC<RecordingControlsProps> = ({
  isRecording,
  isReadyToRecord,
  onStartRecording,
  onStopRecording,
  onCancel
}) => {
  return (
    <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
      <div className="flex items-center gap-6">
        {isRecording ? (
          <>
            <Button 
              onClick={onStopRecording} 
              size="lg" 
              className="rounded-full w-16 h-16 bg-red-600 hover:bg-red-700"
            >
              <Square className="h-8 w-8" />
            </Button>
            <Button 
              onClick={onCancel} 
              size="lg" 
              variant="outline" 
              className="rounded-full w-12 h-12 border-white text-white"
            >
              <X className="h-6 w-6" />
            </Button>
          </>
        ) : (
          <Button
            onClick={onStartRecording}
            disabled={!isReadyToRecord}
            size="lg"
            className={`rounded-full w-16 h-16 ${
              isReadyToRecord ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-600'
            }`}
          >
            <CirclePlay className="h-8 w-8" />
          </Button>
        )}
      </div>
      {!isReadyToRecord && !isRecording && (
        <p className="text-center text-white/70 mt-4 text-sm">
          Cameras initializing...
        </p>
      )}
    </div>
  );
};

export default RecordingControls;
